export default {
  buttons: {
    create: "Créer",
    edit: "Modifier",
    delete: "Supprimer",
    cancel: "Annuler",
    save: "Enregistrer",
    close: "Fermer",
    search: "Rechercher",
    filter: "Filtrer",
    export: "Exporter",
    import: "Importer",
    back: "Retour",
    next: "Suivant",
    previous: "Précédent",
    confirm: "Confirmer",
    duplicate: "Dupliquer",
    rename: "Renommer",
    download: "Télécharger",
    refresh: "Actualiser",
    retry: "Réessayer",
    createProject: "Créer un projet"
  },
  status: {
    draft: "Brouillon",
    validated: "Validé",
    deployed: "Déployé",
    loading: "Chargement...",
    error: "Erreur",
    success: "Succès",
    pending: "En attente"
  },
  labels: {
    name: "Nom",
    description: "Description",
    date: "Date",
    type: "Type",
    actions: "Actions",
    details: "Détails",
    settings: "Paramètres",
    language: "Langue",
    provider: "Fournisseur",
    region: "Région",
    cost: "Coût",
    total: "Total",
    currency: "Devise",
    selectCurrency: "Sélectionner la devise"
  },
  messages: {
    noData: "Aucune donnée disponible",
    confirmDelete: "Êtes-vous sûr de vouloir supprimer ?",
    saveSuccess: "Enregistrement réussi",
    saveError: "Erreur lors de l'enregistrement",
    deleteSuccess: "Suppression réussie",
    deleteError: "Erreur lors de la suppression"
  }
};
